import { useEffect, useState } from "react";

const breakpoints = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400,
};

export const useDeviceType = () => {
  const [deviceTypes, setDeviceTypes] = useState(getDeviceType);

  useEffect(() => {
    const windowSizeHandler = () => {
      setDeviceTypes((prev) => {
        const deviceType = getDeviceType();
        // If all the keys and values are the same, return the previous state
        // to avoid unnecessary churn.
        if (
          Object.entries(deviceType).every(
            ([key, value]) => value === prev[key]
          )
        ) {
          return prev;
        }
        return deviceType;
      });
    };

    window.addEventListener("resize", windowSizeHandler);

    // Call windowSizeHandler initially to set the correct device type
    windowSizeHandler();

    return () => {
      window.removeEventListener("resize", windowSizeHandler);
    };
  }, []);

  return {
    ...deviceTypes,

    /**
     * Hardcoded to false for compatibility, since there is no longer any need
     * for detection logic.
     */
    isDetectingDeviceType: false,
  };
};

export const getDeviceType = () => {
  const width = window.innerWidth;
  return {
    isMobile: width < breakpoints.sm,
    isTablet: width >= breakpoints.sm && width < breakpoints.lg,
    isDesktop: width >= breakpoints.lg && width < breakpoints.xl,
    isLargeDesktop: width >= breakpoints.xl && width < breakpoints.xxl,
    isDesktopAndUp: width >= breakpoints.lg,
  };
};
